import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    className?: string;
}

export const About: FunctionComponent<OwnProps> = ({className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Get organised using crews</h5>
            </div>
            <div className="card-body">
                <p>
                    Schedule your workouts together with your team mates to achieve your goals. Create a crew and invite
                    others to join. You can then schedule workouts for your crew and track your progress, handle
                    attendance and much more.
                </p>
                <p>Some advantages of what you can do with crews:</p>
                <ul>
                    <li>Organise your crew</li>
                    <li>Create a clear schedule</li>
                    <li>Track progress</li>
                    <li>Increase attendance</li>
                </ul>
                <p>...there is so much more to come!</p>
            </div>
        </div>
    );
};
